import { addListStyles } from "@collectivehealth/dls-dropdowns";
import tabDropdownItem from "./tabDropdownItem.css";

addListStyles([
  {
    attributeName: "theme",
    attributeValue: "tab-dropdown-item",
    className: "ignore",
    styles: tabDropdownItem.toString(),
    parts: tabDropdownItem.locals,
    variations: {
      bottom: tabDropdownItem.locals.bottom,
      open: tabDropdownItem.locals.open
    }
  }
]);
